import { render, staticRenderFns } from "./AccountVerificationMessage.vue?vue&type=template&id=36da77f2&scoped=true&"
import script from "./AccountVerificationMessage.vue?vue&type=script&lang=js&"
export * from "./AccountVerificationMessage.vue?vue&type=script&lang=js&"
import style0 from "./AccountVerificationMessage.vue?vue&type=style&index=0&id=36da77f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36da77f2",
  null
  
)

export default component.exports